import { Fragment, useContext } from "react";
import { SummaryStore } from "../..";
import { useHistory } from "react-router";
import { RedBallLoader } from "../ui/Loading";
import { observer } from "mobx-react";

interface Props {
  sectionName: string;
}

const CasesInfoBox = ({ sectionName }: Props) => {
  const summaryStore = useContext(SummaryStore);
  const history = useHistory();

  const hasError = summaryStore.homeDataPollingError;
  const isloading = summaryStore.isHomeSummaryLoading;

  return (
    <div
      id="alert-additional-content-1"
      className={`${
        sectionName === "Case Management" ? "" : "hidden"
      } mt-2 p-4 mb-4 text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800`}
      role="alert"
    >
      {isloading && (
        <div className="h-10">
          <RedBallLoader />
        </div>
      )}
      {!isloading && hasError && (
        <div className="text-red-600 text-left">
          <p>
            Something went wrong loading cases. Please click button to reload
            cases.
          </p>
          <button
            className="mt-2 inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-red-600 rounded-full hover:opacity-75 transition-all focus:ring-4 focus:outline-none"
            onClick={() => {
              summaryStore.refreshHomeData();
            }}
          >
            Retry Load Case
          </button>
        </div>
      )}
      {!isloading &&
        summaryStore &&
        !hasError &&
        [
          {
            title: "Active Cases",
            value: summaryStore?.todayRequestsCount,
          },
          {
            title: "Automatically Closed Cases",
            value: summaryStore?.autoClosedRequestsCount,
          },
          {
            title: "Last 7 Days Cases",
            value: summaryStore?.previousRequestsCount,
          },
        ].map((i, idx) => (
          <div key={`${idx}-cases-info-box`} className="flex items-center">
            <svg
              className="flex-shrink-0 w-4 h-4 me-2"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">Info</span>
            <h3 className="text-lg font-medium">{`${i.title}: ${i && i.value}`}</h3>
          </div>
        ))}
      {!isloading && !hasError && (
        <Fragment>
          <div className="mt-2 mb-4 text-sm">
            More info about this can be viewed at Cases Overview page.
          </div>
          <div className="flex">
            <button
              onClick={() => history.push("/cases")}
              type="button"
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-900 rounded-full hover:opacity-75 transition-all focus:ring-4 focus:outline-none"
            >
              <svg
                className="me-2 h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 14"
              >
                <path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
              </svg>
              View now
            </button>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default observer(CasesInfoBox);
